export const massages = [
  // 🖤 TERAPINĖ LINIJA
  {
    slug: "skaudanti-nugara",
    title: 'Terapija "Skaudanti nugara"',
    duration: "45-60 min",
    price: "40 €",
    description:
      "Gilus ir kryptingas darbas su nugaros, pečių juostos ir kaklo sritimi. Mano masažas paremtas holistiniu požiūriu į žmogų - dirbu su kūnu kaip vientisa sistema, apjungiančia fizinį, emocinį ir energetinį lygmenis. Kiekvienai sesijai intuityviai parenku skirtingas technikas: giluminį darbą, fascijų technikas, limfodrenažinius judesius, somatinius metodus ar lėtą sąmoningą prisilietimą.",
    result:
      "Palengvėjusi nugara, atlaisvinta pečių juosta, lengvumas kūne, ramesnė nervų sistema.",
  },
  {
    slug: "atstatomoji-kuno-terapija",
    title: "Atstatomoji kūno terapija",
    duration: "60-90 min",
    price: "60 €",
    description:
      "Gilus ir kryptingas kūno darbas, apjungiantis kelias terapines technikas. Dirbama su raumenų, fascijų ir nervų sistema, kvėpavimu. Rekomenduojama perdegimui, emocinėms blokadoms, nugaros ir kaklo įtampai, miego sutrikimams.",
    result: "Lengvumas, aiškumas, sumažėję skausmai, gili ramybė kūne.",
  },

  // 🤍 ATSPALAIDUOJANTI LINIJA
  {
    slug: "leto-prisilietimo-masazas",
    title: "Lėto prisilietimo masažas",
    duration: "60-90 min",
    price: "60 €",
    description:
      "Minkštas, sąmoningas ir lėtas prisilietimas, nuraminantis nervų sistemą ir išvedantis kūną į gilaus atsipalaidavimo būseną.",
    result: "Šiluma, ramybė, lengvos mintys, išlaisvintas protas.",
  },
  {
    slug: "holistinis-karstu-lavos-akmenu-masazas",
    title: "Holistinis karštų lavos akmenų masažas",
    duration: "60-90 min",
    price: "60 €",
    description:
      "Šildantis ir giliai atpalaiduojantis masažas su natūraliais lavos akmenimis.",
    result: "Tirpstantis nuovargis, gilus atsipalaidavimas, restarto būsena.",
  },

  // 💧 LIMFODRENAŽO LINIJA
  {
    slug: "limfodrenazas-po-operacijos",
    title: "Limfodrenažas po plastinės operacijos",
    duration: "45-60 min",
    price: "40 €",
    description:
      "Manualinė limfodrenažo terapija skirta po plastinių operacijų.",
    result: "Lengvesnis gijimas, mažesnis patinimas, gražesni kontūrai.",
  },
  {
    slug: "manualinis-limfodrenazinis-viso-kuno",
    title: "Manualinis limfodrenažinis viso kūno masažas",
    duration: "60 min",
    price: "60 €",
    description:
      "Manualinė technika rankomis, be aparatų. Aktyvina limfos tekėjimą, mažina tinimą, sunkumo jausmą, pagerina metabolizmą.",
    result: "Lengvesnės kojos, sumažėjęs tinimas, švaresnis kūno pojūtis.",
  },

  // ✨ VEIDO TERAPIJOS
  {
    slug: "individualizuota-veido-terapija",
    title: "Individualizuota veido terapija",
    duration: "60 min",
    price: "60 €",
    description:
      "Holistinė veido terapija su japoniškomis, miofascialinėmis, osteobukalinėmis ir limfodrenažinėmis technikomis. Dirbama su veido, žandikaulio, kaklo ir galvos sritimi.",
    result:
      "Natūralus liftingas, lengvumas, švytėjimas, atpalaiduota žandikaulio zona.",
  },
  {
    slug: "osteobukalinis-veido-masazas",
    title: "Osteobukalinis veido masažas",
    duration: "60 min",
    price: "60 €",
    description:
      "Specializuota veido ir žandikaulio terapija, atliekama tiek išorėje, tiek burnos ertmėje (su pirštinėmis). Darbas su mimikos raumenimis, fascijomis ir limfa.",
    result:
      "Sumažėjęs patinimas, aiškesni veido kontūrai, švytėjimas ir laisvas kvėpavimas, natūralus liftingas.",
  },

  // 🌹 SIGNATURE RITUALAI
  {
    slug: "pilno-nugaros-ir-veido-atstatymo-ritualas",
    title: "Pilno nugaros ir veido atstatymo ritualas",
    duration: "90-120 min",
    price: "90 €",
    description:
      "Jungia nugaros skausmo terapiją ir individualizuotą veido terapiją.",
    result:
      "Laisva nugara, atpalaiduotas žandikaulis, spindintis veidas ir gili ramybė.",
  },
  {
    slug: "ritualas-moteris",
    title: 'Ritualas "Moteris"',
    duration: "90 min",
    price: "80 €",
    description:
      "Somatinis moteriškas ritualas su dėmesiu šlaunims, sėdmenims, pilvo sričiai ir rankoms. Naudojamas maitinantis ir drėkinantis kremas odos švelnumui ir švytėjimui.",
    result: "Vidinė šviesa, lengvumas širdyje, ramybė ir gyvybingumas kūne.",
  },
  {
    slug: "karaliskas-ritualas-tau",
    title: "Karališkas ritualas Tau",
    duration: "2,5 val.",
    price: "150 €",
    description:
      "2,5 valandos, skirtos tik Tau. Viso kūno, veido ir galvos ritualas, apgaubiantis šiluma, aromatais, aliejais ir rūpestingu rankų prisilietimu. Tai švelnus, moteriškas ir giliai atpalaiduojantis ritualas, kuriame rūpinamasi ne viena kūno dalimi – rūpinamasi Tavimi visa.",
    result:
      "Nuo plaukų iki pirštų galiukų – išmylėtas kūnas. Gilus atsipalaidavimas ir jausmas, lyg būtum šiltame mamos glėbyje.",
  },
];
